import { API_VERSION, APP_CONFIG } from 'mangools-commons/dist/configs/app';
import { parse } from 'sources/parsers/CurrencyDataParser';

import HumanService from 'mangools-commons/dist/services/HumanService';
import ErrorCodes from 'mangools-commons/dist/constants/ErrorCodes';

// Constants
const ENDPOINT = `/${API_VERSION}/system/currencies`;

class CurrencyRatesSource {
    static getData(accessToken) {
        const requestURL = `${APP_CONFIG.API_HOST}${ENDPOINT}`;

        return fetch(requestURL, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'X-Access-Token': accessToken || '',
                'X-Human-Token': HumanService.gen(),
                'X-Mangools-Client': 'app',
            },
        })
            .then(response => {
                if (response.ok) {
                    return response
                        .json()
                        .then(data => ({
                            error: false,
                            payload: parse(data),
                        }))
                        .catch(ex => ({
                            error: true,
                            payload: {
                                requestURL,
                                status: ErrorCodes.PARSE_ERROR,
                                text: ex.toString(),
                            },
                        }));
                } else {
                    return response.json().then(e => ({
                        error: true,
                        payload: {
                            requestURL,
                            status: response.status,
                            text: e.error ? e.error.message : null,
                            type: e.error ? e.error.type : null,
                            retryAfter: e.error ? e.error.retry_after : null,
                        },
                    }));
                }
            })
            .catch(ex => ({
                error: true,
                payload: {
                    requestURL,
                    status: ErrorCodes.FETCH_ERROR,
                    text: ex.toString(),
                },
            }));
    }
}

export default CurrencyRatesSource;
